<div class="row justify-content-between align-items-center journey-step-row">
  <div class="col-lg-6 col-12 order-1 order-lg-2 right-form-col">
    <div class="assist-card-unified">
      <!-- Blue Box Header -->
      <div class="blue_box p-3 text-center">
        <h3 class="heading">{{ isConfirmed ? 'Loan Confirmed' : 'Verify Your Mobile Number' }}</h3>
      </div>

      <!-- White Box Content -->
      <div class="white_box p-4">
        <!-- 1. Initializing / Loading Spinner (only before OTP is triggered) -->
        <div *ngIf="isInitializing && !isOtpSent" class="text-center py-4">
          <div class="spinner-border mb-3" role="status" style="width: 3rem; height: 3rem; color: #044b5f;">
            <span class="visually-hidden">Loading...</span>
          </div>
          <h5 style="font-family: 'Noto Serif', serif; color: #002d3a; font-weight: 500;">Initiating Transaction...</h5>
          <p class="text-muted small">Please wait while we connect with 1Fi to process your loan booking.</p>
        </div>

        <!-- 2. Error State -->
        <div *ngIf="hasError && !isOtpSent" class="text-center py-3">
          <div class="text-danger my-3">
            <i class="fas fa-exclamation-triangle fa-3x"></i>
          </div>
          <h4 style="font-family: 'Noto Serif', serif; color: #dc3545; font-weight: 500;">Transaction Failed</h4>
          <p class="text-muted small mb-3">{{ errorMessage }}</p>
          <div class="row justify-content-center text-center buttonDiv">
            <div class="col-12">
              <button type="button" class="btn btn-warning" (click)="retryInit()">
                <i class="fas fa-redo me-1"></i> Try Again
              </button>
            </div>
          </div>
        </div>

        <!-- 3. OTP Verification Form (visible as soon as OTP is sent or initialization completes) -->
        <div *ngIf="(isOtpSent || !isInitializing) && !isConfirmed" class="otp-verification-section">
          <!-- Loan Amount summary (if available) -->
          <div class="approved-banner text-center mb-3" *ngIf="loanAmount">
            <span class="d-block banner-label">Approved Loan Amount</span>
            <span class="banner-amount">₹{{ loanAmount | number:'1.0-0' }}</span>
          </div>

          <!-- Prompt text -->
          <p class="text-center mobile-otp-subtext">
            Enter the OTP sent on your mobile
            <strong>{{ maskedMobileNumber }}</strong>
          </p>

          <!-- OTP Input -->
          <div class="row justify-content-center">
            <div class="form-group text-center">
              <ng-otp-input [config]="otpInputConfig" (onInputChange)="onOtpChange($event)"></ng-otp-input>
            </div>
          </div>

          <!-- Verify Button & Timer -->
          <div class="row justify-content-center mt-2 text-center buttonDiv">
            <div class="col-12">
              <button
                type="submit"
                class="btn btn-warning mt-3"
                [disabled]="isVerifyingOtp || !otpValue || otpValue.length < 4"
                (click)="confirmLoanOtp()"
                tabindex="0"
              >
                <span *ngIf="isVerifyingOtp" class="spinner-border spinner-border-sm me-1" role="status"></span>
                {{ isVerifyingOtp ? 'Verifying...' : 'Verify' }}
              </button>
            </div>

            <div class="timer-container mt-2">
              <span *ngIf="!canResend">Didn't you receive any code? {{ resendCountdown }}s</span>
              <button *ngIf="canResend" class="btn btn-link btn-response" (click)="resendOtp()" tabindex="0">
                <i class="fa fa-paper-plane" aria-hidden="true" style="color: #044b5f; font-size: 1em;"></i>
                <span style="color: #044b5f; font-weight: 500; margin-left: 5px;">Resend OTP</span>
              </button>
            </div>

            <p class="info m-0 mt-3 text-center">
              <i class="fas fa-lock" style="color: #044b5f;"></i> Authorized &amp; Secured by 1Fi
            </p>
          </div>
        </div>

        <!-- 4. Confirmed / Success State -->
        <div *ngIf="isConfirmed && confirmData" class="success-section text-center py-2">
          <div class="my-3 text-success">
            <i class="fas fa-check-circle fa-4x" style="color: #28a745;"></i>
          </div>

          <h4 style="font-family: 'Noto Serif', serif; color: #002d3a; font-weight: 500;">
            Loan Confirmed Successfully!
          </h4>
          <p class="sub-heading mt-2" style="font-size: 0.95rem; color: #474747;">
            Your <b>Travel Now, Pay Later</b> loan has been confirmed with <b>1Fi</b>.
          </p>

          <div class="loan-details-summary text-start p-3 my-3">
            <p class="mb-2" *ngIf="confirmData.loan_number">
              <strong>Loan Number:</strong> {{ confirmData.loan_number }}
            </p>
            <p class="mb-2" *ngIf="confirmData.order_number">
              <strong>Order Number:</strong> {{ confirmData.order_number }}
            </p>
            <p class="mb-0" *ngIf="confirmData.loan_status">
              <strong>Status:</strong>
              <span class="badge" style="background: #044b5f; color: #fff;">{{ confirmData.loan_status }}</span>
            </p>
          </div>

          <div class="row justify-content-center text-center buttonDiv">
            <div class="col-12">
              <button type="button" class="btn btn-warning mt-2" (click)="navigateToSuccess()">
                Continue <i class="fas fa-arrow-right ms-1"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Left Trust Panel -->
  <div class="col-lg-5 col-12 order-2 order-lg-1 left-trust-col mt-4 mt-lg-0">
    <app-assist-left [isFloating]="false"></app-assist-left>
  </div>
</div>
<ngx-spinner type="ball-spin-clockwise" size="medium"></ngx-spinner>
